import type { AccordionDetailsProps, AccordionProps, AccordionSummaryProps } from '@mui/material';
import {
  Accordion as MuiAccordion,
  AccordionDetails as MuiAccordionDetails,
  AccordionSummary as MuiAccordionSummary
} from '@mui/material';

export type { AccordionProps, AccordionDetailsProps, AccordionSummaryProps };

export const Accordion = ({
  disableGutters = true,
  elevation = 0,
  square = true,
  ...props
}: AccordionProps) => (
  <MuiAccordion
    disableGutters={disableGutters}
    elevation={elevation}
    square={square}
    {...props}
  />
);

export const AccordionSummary = (props: AccordionSummaryProps) => (
  <MuiAccordionSummary {...props} />
);

export const AccordionDetails = (props: AccordionDetailsProps) => (
  <MuiAccordionDetails {...props} />
);
